export const config = {
  apiurl: process.env.REACT_APP_APIURL,
  fileurl: "http://avathardb.m8itsolutions.in/" || process.env.REACT_APP_FILEURL,
}
